import context from '@/context'
import { fromJS, List, Map } from 'immutable'
import { actionCreators as myActiveTasksActionCreators } from '@/store/myActiveTask'

const initialState = Map({
  data: Map({})
})

function toJSON (immutableObj) {
  return immutableObj ? JSON.stringify(immutableObj.toJS()) : null
}

export function getUid (scope, id, isChangeItemId) {
  return `/${scope}/${isChangeItemId || ''}${id}`
}

export const actionTypes = {
  toggleReviewButtons: 'forms/toggleReviewButtons',
  savingApproval: 'forms/savingApproval',
  changeApproval: 'forms/changeApproval',
  change: 'forms/change',
  addItem: 'forms/addItem',
  removeItem: 'forms/removeItem',
  editItemLoading: 'forms/editItemLoading',
  editItemLoaded: 'forms/editItemLoaded',
  deleteItem: 'forms/deleteItem',
  dataLoading: 'forms/dataLoading',
  dataLoaded: 'forms/dataLoaded',
  dataLoadFailed: 'forms/dataLoadFailed',
  saving: 'forms/saving',
  saved: 'forms/saved',
  saveFailed: 'forms/saveFailed',
  removeData: 'forms/removeData'
}

export const actionCreators = {
  dataLoading: uid => (
    { type: actionTypes.dataLoading, uid }
  ),
  dataLoaded: (uid, data) => (
    { type: actionTypes.dataLoaded, data, uid }
  ),
  dataLoadFailed: (uid, error) => (
    { type: actionTypes.dataLoadFailed, uid, error }
  ),
  removeData: (uid) => (
    { type: actionTypes.removeData, uid }
  ),
  change: (uid, target, value, additionalChanges, onComplete = () => {}) => dispatchAndPersist({ type: actionTypes.change, uid, changes: [{ target: target, value: value }, { target: '__isModified', value: true }, ...(additionalChanges || [])] }, onComplete),
  addItem: (uid, target, sourceUid) => dispatchAndPersist({ type: actionTypes.addItem, uid, target, sourceUid }),
  removeItem: (uid, target, value) => dispatchAndPersist({ type: actionTypes.removeItem, uid, target, value }),
  deleteItem: (uid, target, value) => dispatchAndPersist({ type: actionTypes.deleteItem, uid, target, value }),
  toggleReviewButtons: (propertyName) => {
    return { type: actionTypes.toggleReviewButtons, propertyName: propertyName }
  },
  changeApproval: (uid, propertyName, approved, approvedValue) => (dispatch, getState) => {
    const forms = getState().forms
    const parentUid = forms.getIn(['data', uid, 'parentUid'])
    if (parentUid) uid = parentUid
    const changeItemId = forms.getIn(['data', uid, 'id'])
    let savingApproval = forms.getIn(['data', uid, 'savingApproval'])
    if (savingApproval) return
    dispatch({ type: actionTypes.savingApproval, uid, propertyName })
    context.api.changeRequestService.updateApproval({
      changeItemId: changeItemId,
      key: propertyName,
      approved: approved
    }).then(() => {
      dispatch({ type: actionTypes.changeApproval, uid, propertyName, approved, approvedValue })
    }).catch(() => {
      dispatch({ type: actionTypes.changeApproval, uid, propertyName, revert: true })
    })
  },
  persistChanges: (uid) => (dispatch, getState) => {
    const state = getState().forms
    const myActiveTask = getState().myActiveTask
    const changeItem = state.getIn(['data', uid])
    const version = changeItem.get('version') || 1
    const savedVersion = changeItem.get('savedVersion') || 1
    if (version === savedVersion) return
    console.log(context)
    const request = {
      id: changeItem.get('id') ? changeItem.get('id') : myActiveTask.activeTask.changeRequest.items[0].id,
      data: toJSON(changeItem.get('modifiedData')),
      originalData: toJSON(changeItem.get('originalData')),
      origin: context.isInternalApp()
    }
    dispatch({ type: actionTypes.saving, uid, version })
    return context.api.changeRequestService.updateChangeItem(request).then(response => {
      if (response.success) {
        dispatch({ type: actionTypes.saved, uid, version })
        dispatch(myActiveTasksActionCreators.getMyActiveTask())
      } else {
        const validationErrors = (response.validationErrors || ['']).join(',\n')
        dispatch({ type: actionTypes.saveFailed, uid, version, validationErrors })
      }
    }).catch(() => {
      dispatch({ type: actionTypes.saveFailed, uid, version })
    })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.dataLoading:
      return state.deleteIn(['data', action.uid])
    case actionTypes.dataLoaded:
      return state.setIn(['data', action.uid], fromJS(action.data))
    case actionTypes.dataLoadFailed:
      return state.setIn(['data', action.uid], Map({})) // TODO: what else?
    case actionTypes.removeData:
      return state.deleteIn(['data', action.uid])

    case actionTypes.savingApproval: {
      return state.setIn(['data', action.uid, 'savingApproval'],
        state.getIn(['data', action.uid, 'approvalInfo', action.propertyName]))
    }
    case actionTypes.changeApproval: {
      const prevValue = state.getIn(['data', action.uid, 'savingApproval', action.propertyName])
      state = state.deleteIn(['data', action.uid, 'savingApproval'])
      const propertyPath = getDataPath(state, action.uid, action.propertyName.split(/[.[\]]/).filter(x => x !== ''), 'approvedValues')

      if (action.propertyName.endsWith(']')) {
        if (!action.revert) state = state.setIn(propertyPath, Map(action.approvedValue))
        return state.updateIn(['data', action.uid, 'approvalInfo'], a => a.map((v, k) => k.startsWith(action.propertyName) ? action.approved : v))
      }
      if (!action.revert) state = state.setIn(propertyPath, action.approvedValue)
      return state.setIn(['data', action.uid, 'approvalInfo', action.propertyName], action.revert ? prevValue : action.approved)
    }
    case actionTypes.toggleReviewButtons: {
      return state.update('showReviewButtonsFor', x => x !== action.propertyName ? action.propertyName : null)
    }
    case actionTypes.change: {
      for (let i = 0; i < action.changes.length; i++) {
        const change = action.changes[i]
        state = state.setIn(getDataPath(state, action.uid, change.target), fromJS(change.value))
      }
      return incrementVersion(state, action.uid)
    }
    case actionTypes.addItem: { // add new item to collection (INSERT)
      return cases.addItem(state, action)
    }
    case actionTypes.removeItem: { // remove item from change item's collection (UNDO)
      return cases.undoItem(state, action)
    }
    case actionTypes.editItemLoading: {
      state = state.updateIn(getDataPath(state, action.uid, action.target), arr => addItem(arr, { ...action.value, loading: true }))
      return incrementVersion(state, action.uid)
    }
    case actionTypes.editItemLoaded: {
      state = state.updateIn(getDataPath(state, action.uid, action.target), arr => addItem(arr, action.value))
      return incrementVersion(state, action.uid)
    }
    case actionTypes.deleteItem: { // marks existing record as deleted
      state = state.updateIn(getDataPath(state, action.uid, action.target), arr => addItem(arr, Map(action.value).set('isDeleted', true)))
      return incrementVersion(state, action.uid)
    }
    case actionTypes.saving: {
      return state.setIn(['data', action.uid, 'savingVersion'], action.version)
        .setIn(['data', action.uid, 'errorVersion'], -1)
    }
    case actionTypes.saved: {
      return state.setIn(['data', action.uid, 'savedVersion'], action.version)
    }
    case actionTypes.saveFailed: {
      return state.setIn(['data', action.uid, 'errorVersion'], action.version)
        .setIn(['data', action.uid, 'errorMessage'], action.validationErrors)
    }
    case '@@router/LOCATION_CHANGE': {
      const uid = action.payload.pathname
      return state.deleteIn(['data', uid])
    }
    default: break
  }
  return state
}

const cases = {
  addItem: (state, action) => {
    if (action.sourceUid) {
      const value = state.getIn(getDataPath(state, action.sourceUid, ''))
      const originalValue = state.getIn(getDataPath(state, action.sourceUid, '', 'originalData'))
      if (originalValue) {
        // check if there is any change compared to originalValue
        if (value.equals(originalValue)) {
          const jsValue = value.toJS()

          if (jsValue.__isCreated !== true) return cases.undoItem(state, { ...action, value: jsValue })
        }
        state = state.updateIn(getDataPath(state, action.uid, '', 'originalData'), orig => orig || Map())
        state = state.updateIn(getDataPath(state, action.uid, action.target, 'originalData'), arr => addOriginal(arr, originalValue))
      }
      state = state.updateIn(getDataPath(state, action.uid, action.target), arr => addItem(arr, value))
      return incrementVersion(state, action.uid)
    }
    return state
  },
  undoItem: (state, action) => {
    const stateBefore = state
    state = state.updateIn(getDataPath(state, action.uid, action.target), arr => removeItem(arr, action.value))
    return stateBefore.equals(state) ? state : incrementVersion(state, action.uid)
  }
}

function incrementVersion (state, uid) {
  return state.updateIn(['data', uid, 'version'], x => (x || 1) + 1)
}

function addItem (list, item) {
  if (!List.isList(list)) list = List()
  let id = item.get('id')
  const isFileAttachment = item.get('__IS_FILEATTACHMENT')
  if (typeof id !== 'number' && !isFileAttachment) {
    const minItem = list ? list.filter(x => x.get('id') < 0).minBy(x => x.get('id')) : null
    id = (minItem ? minItem.get('id') - 1 : -1) || -1
    item = item.set('id', id)
  }
  const index = list.findIndex(i => i.get('id') === id)
  return (index < 0) ? list.push(item) : list.update(index, () => item)
}

function addOriginal (list, item) {
  if (!item) return list
  if (!List.isList(list)) list = List()
  let id = item.get('id')
  if (id > 0) {
    const index = list.findIndex(i => i.get('id') === id)
    if (index < 0) {
      return list.push(item)
    }
  }
  return list
}

function removeItem (list, item) {
  if (List.isList(list) && item && (typeof item.id === 'number' || item.__IS_FILEATTACHMENT)) {
    const index = list.findIndex(x => x.get('id') === item.id)
    if (index >= 0) {
      return list.remove(index)
    }
  }
  return list
}

export function getDataPath (state, uid, target, source = 'modifiedData') {
  const basePath = ['data', uid, source]
  let targetPath = []
  if (target) {
    let node = state.getIn(basePath)
    targetPath = typeof target === 'string' ? target.split('.') : [...target]

    for (let i = 0; i < targetPath.length; i++) {
      if (!node) break
      const step = targetPath[i]
      if (List.isList(node) && /-?\d+/.test(step)) { // find list item by id
        const id = parseInt(step, 10)
        const predicate = x => x.get('id') === id
        const index = node.findIndex(predicate)
        if (index >= 0) {
          targetPath[i] = index
        }
        node = node.find(predicate)
      } else {
        node = node.get(step)
      }
    }
  }
  return [...basePath, ...targetPath]
}

let savingHandle = 0

function dispatchAndPersist (action, onComplete = () => {}) {
  return function (dispatch, getState) {
    const { myActiveTask } = getState()

    if (myActiveTask && (!myActiveTask.activeTask || !myActiveTask.activeTask.changeRequestId)) {
      onComplete()
      return
    }
    dispatch(action)
    if (!action.uid.startsWith('#')) {
      clearTimeout(savingHandle)
      savingHandle = setTimeout(() => {
        Promise.resolve(actionCreators.persistChanges(action.uid)(dispatch, getState))
          .finally(onComplete)
          .catch(error => {
            console.error('Error persisting changes:', error)
          })
      }, 2500)
    } else {
      onComplete()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Forms.js